import { WixConnect } from 'shared/utils/wix-connect';

import styles from './clickable.styl';


@WixConnect(styles)
export default class Clickable extends React.Component {

  static propTypes = {
    children: React.PropTypes.any,
    onClick: React.PropTypes.func,
    style: React.PropTypes.object,
  };

  render() {
    const { style, onClick, children } = this.props;

    const childProps = _.omit(this.props, 'onClick', 'style');

    return (
      <div styleName="clickable"
           onClick={onClick}
           style={style}>
        {
          React.Children.map(children, elem => React.cloneElement(elem, childProps))
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/containers/clickable/clickable.js